module.exports = __webpack_public_path__ + "img/news.ffd05e0e.jpg";